import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { Input } from '../../../assets/styled/Element';
import { useSnackbar } from 'notistack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { endOfDay, format } from 'date-fns';
import { enUS, th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { Controller, useForm } from 'react-hook-form';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import { MySelect } from '../../../components/Select/Select';
import {
   RedeemLabel,
   ShippingLabel,
} from '../../../components/Status/StatusLabel';
import {
   faExternalLinkSquare,
   faFilter,
} from '@fortawesome/pro-duotone-svg-icons';
import History from '../../../components/Modal/Redeemptions/History';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function RedeemptionHistory(props) {
   const tableRef = React.createRef();
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const [rewardRes, setRewardRes] = useState([]);
   const [optionsReward, setOptionsReward] = useState([]);
   const [rewardLoading, setRewardLoading] = useState(false);
   const [pageSize, setPageSize] = useState(5);
   const [page, setPage] = useState(1);
   const [keyword, setKeyword] = useState('');
   const [rewardId, setRewardId] = useState(null);
   const [rewardLabel, setRewardLabel] = useState('');
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
      reset,
   } = useForm({
      defaultValues: {
         rewards: null,
         referenceSearch: null,
         customerSearch: null,
         startDate: new Date('01/01/2020 00:00:00'),
         endDate: new Date(),
         keyword: '',
      },
   });
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);
   useEffect(() => {
      // getData({
      //   start: 0,
      //   limit: pageSize,
      //   rewardId: rewardId,
      //   startDate: format(selectStartDate, 'dd/MM/yyyy HH:mm:ss'),
      //   endDate: format(selectEndDate, 'dd/MM/yyyy HH:mm:ss'),
      //   referenceSearch: null,
      //   customerSearch: null,
      //   keyword: keyword,
      // });
   }, []);
   useEffect(() => {
      getReward();
   }, []);
   useEffect(() => {
      setTableData();
   }, [resp]);
   useEffect(() => {
      setReward();
   }, [rewardRes]);
   const handleStartDateChange = (e) => {
      setValue('startDate', e);
   };
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   const onSubmit = (e) => {
      console.log('e: ', e);
      sessionStorage.setItem('value', JSON.stringify(e));
      // setData([]);
      // getData({
      //   start: 0,
      //   limit: pageSize,
      //   rewardId: rewardId,
      //   startDate: format(selectStartDate, 'dd/MM/yyyy HH:mm:ss'),
      //   endDate: format(selectEndDate, 'dd/MM/yyyy HH:mm:ss'),
      //   referenceSearch: null,
      //   customerSearch: null,
      //   keyword: keyword,
      // });
      setPage(1);
      tableRef.current && tableRef.current.onQueryChange();
   };
   const getData = (query) => {
      return new Promise((resolve, reject) => {
         setIsLoading(true);
         Axios.post('/GSB/dashboard/reward/GetRedemptionList', {
            start: query ? query.page * query.pageSize : page * pageSize ?? 0,
            limit: query ? query.pageSize : pageSize ?? 5,
            rewardId: rewardId ?? null,
            startDate: format(selectStartDate, 'dd/MM/yyyy HH:mm:ss'),
            endDate: format(selectEndDate, 'dd/MM/yyyy HH:mm:ss'),
            referenceSearch: null,
            customerSearch: null,
            keyword: query ? query.search : keyword ?? '',
         })
            .then((response) => {
               // setResp(response.data.payload);
               setPage(query.page);
               setPageSize(query.pageSize);
               setKeyword(query.search);
               resolve({
                  data: response.data.payload,
                  page: response.data.currentpage - 1,
                  totalCount: response.data.totalRecord,
               });
            })
            .catch((e) => {
               LogToBackend(e);
               if (e.response) {
                  const response = e.response.data;
                  const statusCode = e.response.status;
                  if (statusCode === 401) {
                     sessionStorage.clear();
                     localStorage.clear();
                     history.push('/');
                  }
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               if (sessionStorage['value']) sessionStorage.removeItem('value');
               setIsLoading(false);
            });
      });
   };
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const getReward = () => {
      setRewardLoading(true);
      Axios.get('/GSB/dashboard/reward/GetList')
         .then((response) => {
            setRewardRes(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {});
   };
   const setReward = () => {
      if (rewardRes.length > 0) {
         const dataForMap = rewardRes;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  value: value.rewardId,
                  label: value.rewardTh,
               },
            );
         });
         setRewardLoading(false);
         setOptionsReward(formatted);
      }
   };
   const setModalStyle = (type, value) => {
      if (type === 'history') {
         setMyModal(
            <History
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() =>
                  tableRef.current && tableRef.current.onQueryChange()
               }
            />,
         );
      }
      setShowModal(!showModal);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>
                  เรียกดูประวัติการแลกของรางวัล
               </Typography>
            </Box>
         </Box>
         <Box
            m={1}
            p={1}
            style={{
               background: '#f6f6f6',
               borderRadius: '10px',
            }}
         >
            <form onSubmit={handleSubmit(onSubmit)}>
               <Box
                  display={'flex'}
                  alignItems={'flex-start'}
                  flexDirection={'column'}
                  fontSize={20}
               >
                  <Box width={'100%'}>
                     <Grid container spacing={2}>
                        <Grid item xs={3}>
                           <TitleLabel Fs={'14px'}>
                              ตั้งแต่&nbsp;:&nbsp;
                           </TitleLabel>
                           <Box width={'100%'} style={{ position: 'relative' }}>
                              <DatePicker
                                 date={selectStartDate}
                                 onDateChange={handleStartDateChange}
                                 // locale={th}
                                 // format="dd MMM yyyy"
                                 locale={enUS}
                              >
                                 {({ inputProps, focused }) => (
                                    <Box width={'100%'}>
                                       <Input
                                          className={
                                             'input' +
                                             (focused ? ' -focused' : '')
                                          }
                                          {...inputProps}
                                          value={`${
                                             inputProps.value &&
                                             dayjs(
                                                new Date(inputProps.value),
                                             ).format('DD/MM/BBBB')
                                          }`}
                                          width={'51%'}
                                          margin={'0px 3% 0px 0px'}
                                          placeholder={'เลือกวันที่'}
                                          readOnly
                                       />
                                       <Input
                                          className='input'
                                          {...timeStartInputProps}
                                          width={'46%'}
                                          type={'time'}
                                       />
                                    </Box>
                                 )}
                              </DatePicker>
                           </Box>
                        </Grid>
                        <Grid item xs={3}>
                           <TitleLabel Fs={'14px'}>
                              จนถึง&nbsp;:&nbsp;
                           </TitleLabel>
                           <Box width={'100%'} style={{ position: 'relative' }}>
                              <DatePicker
                                 date={selectEndDate}
                                 onDateChange={handleEndDateChange('auto')}
                                 // locale={th}
                                 // format="dd MMM yyyy"
                                 minimumDate={
                                    getValues('startDate')
                                       ? getValues('startDate')
                                       : new Date()
                                 }
                                 locale={enUS}
                              >
                                 {({ inputProps, focused }) => (
                                    <Box width={'100%'}>
                                       <Input
                                          className={
                                             'input' +
                                             (focused ? ' -focused' : '')
                                          }
                                          {...inputProps}
                                          value={`${
                                             inputProps.value &&
                                             dayjs(
                                                new Date(inputProps.value),
                                             ).format('DD/MM/BBBB')
                                          }`}
                                          width={'51%'}
                                          margin={'0px 3% 0px 0px'}
                                          placeholder={'เลือกวันที่'}
                                          readOnly
                                       />
                                       <Input
                                          className='input'
                                          {...timeEndInputProps}
                                          width={'46%'}
                                          type={'time'}
                                       />
                                    </Box>
                                 )}
                              </DatePicker>
                           </Box>
                        </Grid>
                        <Grid item xs={3}>
                           <TitleLabel Fs={'14px'}>
                              ชื่อของรางวัล&nbsp;:&nbsp;
                           </TitleLabel>
                           <Controller
                              as={
                                 <MySelect
                                    defaultValue={rewardLabel}
                                    options={optionsReward}
                                    placeholder={'เลือกของรางวัล'}
                                    closeMenuOnSelect
                                    isLoading={rewardLoading}
                                    menuShowInbody={true}
                                 />
                              }
                              onChange={([selected]) => {
                                 setRewardId(selected.value);
                                 setRewardLabel(selected.label);
                                 return selected;
                              }}
                              name='rewards'
                              control={control}
                           />
                        </Grid>
                        <Grid item xs={3}>
                           <TitleLabel Fs={'14px'}>
                              อื่น ๆ&nbsp;:&nbsp;
                           </TitleLabel>
                           <Input
                              name={'keyword'}
                              placeholder={'อื่น ๆ'}
                              ref={register()}
                           />
                        </Grid>
                     </Grid>
                  </Box>
                  <Box
                     mt={1}
                     display={'flex'}
                     justifyContent={'flex-end'}
                     width={'100%'}
                  >
                     <Button
                        variant={'contained'}
                        size={'small'}
                        color={'primary'}
                        type={'submit'}
                        startIcon={
                           <FontAwesomeIcon icon={faFilter} size={'xs'} />
                        }
                        onClick={() => {
                           setPage(1);
                           tableRef.current && tableRef.current.onQueryChange();
                        }}
                     >
                        ตัวกรอง
                     </Button>
                     <Button
                        size={'small'}
                        onClick={() => {
                           setPage(1);
                           setKeyword('');
                           setValue('startDate', new Date('01/01/2020'));
                           setValue('endDate', new Date());
                           setRewardId(null);
                           setRewardLabel('');
                           tableRef.current && tableRef.current.onQueryChange();
                        }}
                     >
                        ล้าง
                     </Button>
                  </Box>
               </Box>
            </form>
         </Box>
         <Box>
            <MaterialTable
               isLoading={isLoading}
               tableRef={tableRef}
               columns={[
                  {
                     field: 'redeemStatusDesc',
                     title: 'สถานะ',
                     width: 100,
                     sorting: false,
                     export: false,
                     headerStyle: {
                        textAlign: 'center',
                     },
                     cellStyle: {
                        textAlign: 'center',
                     },
                     render: (rowData) =>
                        rowData.redeemStatusDesc ? (
                           <RedeemLabel
                              StatusType={rowData.redeemStatus}
                              msg={rowData.redeemStatusDesc}
                           />
                        ) : null,
                  },
                  {
                     field: 'rewardName',
                     title: ' ชื่อของรางวัล',
                     render: (rowData) => rowData.rewardNameTh,
                  },
                  {
                     field: 'redeemerOrgEmployeeId',
                     title: 'รหัสพนักงาน',
                     type: 'numeric',
                  },
                  {
                     field: 'redeemer',
                     title: 'ชื่อพนักงาน',
                     render: (rowData) => rowData.redeemerTh,
                  },
                  {
                     field: 'qty',
                     title: 'จำนวน',
                     type: 'numeric',
                  },
                  {
                     field: 'formattedPoint',
                     title: 'คะแนน',
                     type: 'numeric',
                  },
                  {
                     field: 'shippingStatusDesc',
                     title: 'การจัดส่ง',
                     sorting: false,
                     export: false,
                     headerStyle: {
                        textAlign: 'center',
                     },
                     cellStyle: {
                        textAlign: 'center',
                     },
                     render: (rowData) =>
                        rowData.shippingStatusDesc ? (
                           <ShippingLabel
                              StatusType={+rowData.shippingStatus}
                              msg={rowData.shippingStatusDesc}
                           />
                        ) : null,
                  },
                  {
                     field: 'redeemTime',
                     title: 'วันที่แลก',
                     type: 'datetime',
                     render: (rowData) =>
                        dayjs(new Date(rowData.redeemTime)).format(
                           'DD/MM/BBBB  HH:mm',
                        ),
                  },
               ]}
               // data={data}
               data={(query) => getData(query)}
               options={{
                  showTitle: false,
                  headerStyle: headerStyle,
                  padding: 'dense',
                  actionsColumnIndex: -1,
                  actionsCellStyle: {
                     color: '#ccc',
                  },
                  addRowPosition: 'first',
                  pageSize: pageSize,
                  pageSizeOptions: [5, 10, 25, 50, 100],
               }}
               localization={{
                  header: { actions: 'ตัวจัดการ' },
               }}
               style={tableStyle}
               actions={[
                  {
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faRedoAlt}
                           size={'xs'}
                        />
                     )),
                     tooltip: 'Refresh Data',
                     isFreeAction: true,
                     onClick: () =>
                        tableRef.current && tableRef.current.onQueryChange(),
                  },
                  (rowData) => ({
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faExternalLinkSquare}
                        />
                     )),
                     tooltip: 'เพิ่มเติม',
                     onClick: (event, rowData) =>
                        setModalStyle('history', rowData),
                  }),
               ]}
               icons={tableIcons}
            />
         </Box>
      </Paper>
   );
}

export default RedeemptionHistory;
